/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useEffect } from "react";
import { ScrollView, View } from "react-native";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import { Text } from "UpduoLibrary";
import {
  skaleWhite,
  skaleWebBorderGray,
  skaleWebFillGray,
} from "config/UpduoColors";
import GraphSidebarRow from "./GraphSidebarRow";

export default function GraphSidebar({
  onSetDisplayedPlot,
  selectedPlotIdArray,
}) {
  const timeSeriesData = useSelector(
    (state: RootState) => state.timeSeriesData
  );
  const fullDataQueryType = useSelector(
    (state: RootState) => state.fullDataQueryType
  );

  useEffect(() => {
    let idArray = [];
    if (fullDataQueryType) {
      idArray =
        timeSeriesData?.[fullDataQueryType]?.data_sets?.map(
          (item) => item.id
        ) || [];
    }
    onSetDisplayedPlot(idArray);
  }, [timeSeriesData, fullDataQueryType]);

  const _handleSelectPlot = (plotId) => {
    const result = selectedPlotIdArray;

    if (result.includes(plotId)) {
      const index = result.indexOf(plotId);
      if (index > -1) {
        result.splice(index, 1);
      }
    } else {
      result.push(plotId);
    }
    onSetDisplayedPlot(result);
  };

  if (!fullDataQueryType) {
    // TODO maybe show sidebar for progress report
    return null;
  }

  const sidebarRows =
    timeSeriesData?.[fullDataQueryType]?.data_sets?.map((item, itemIndex) => (
      <GraphSidebarRow
        key={itemIndex}
        item={item}
        itemType={timeSeriesData[fullDataQueryType]["data_type"]}
        rowIndex={itemIndex + 1}
        isActive={selectedPlotIdArray.includes(item.id)}
        onSelectPlot={_handleSelectPlot}
      />
    )) || [];

  return (
    <View
      style={{
        flex: 1,
        borderBottomWidth: 1,
        borderRightWidth: 1,
        borderColor: skaleWebBorderGray,
        backgroundColor: skaleWhite,
      }}
    >
      <View
        style={{
          backgroundColor: skaleWebFillGray,
          alignItems: "center",
          borderBottomWidth: 1,
          borderColor: skaleWebBorderGray,
        }}
      >
        <Text style={{ marginVertical: 5 }}>
          {timeSeriesData?.[fullDataQueryType]?.data_type?.toUpperCase()}
        </Text>
      </View>
      <ScrollView style={{ flexBasis: 1 }}>{sidebarRows}</ScrollView>
    </View>
  );
}
